module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionAlbb.7178eef4.png";